import React, { useState, useEffect } from 'react';
import '../css/intro.scss';

function Intro() {
  // 띄워야 할 문자열
  let skill = ['REACT', 'TYPESCRIPT', "SASS"];
  // 문자 배열 번호
  let [i, seti] = useState(0);
  // 띄워야 할 문자열의 순서 정하기
  let text = skill[i];
  // N초마다 이전 텍스트 + 현재 택스트를 합쳐줄 변수
  let [landingText, setLandingText] = useState('');
  // 완성할 문자의 길이를 넘으면 안되므로 글자 수를 세는 변수 추가
  let [count, setCount] = useState(0);
  // N초마다 글자 1개씩 추가하며 보여주기
  useEffect(() => {
    let typingInterval = setInterval(() => {
      // prev는 문자를 글자 하나하나로 쪼갠 뒤 합쳐진 것이다.
      setLandingText((prev) => {
        // prev => 이전 합쳐진 값
        // completedWord[count] => 현재 값
        // result = 이전 값 + 현재 값
        let result = prev ? prev + text[count] : text[0];
        setCount(count + 1);
        // result가 문자열의 길이보다 길어질 경우 0으로 초기화
        if (count >= text.length) { 
          // 해당 문자열의 첫 글자로 돌린다.
          setCount(0);
          // 띄워야 할 문자 배열의 마지막에 도달할 경우 배열의 처음으로 돌린다.
          if (i >= skill.length - 1) { seti( 0 ); } 
          else { seti(i + 1); }
          // 문자 초기화
          setLandingText('');
        }
        return result;
      })
    }, 250);

    return () => { clearInterval(typingInterval); };
  });
  // // function end

  return (
    <section className='intro'>
      <video muted autoPlay loop>
        <source src={process.env.PUBLIC_URL + "/assets/img/Alone - 46637.mp4"} type='video/mp4'/>
      </video>
      <div className='txtBox'>
        <h1>
          Hi! <br/>
          I'm <span className='typingText'>{landingText}</span><br/>
          Developer
        </h1>
        <p>
          안녕하세요. 신입 REACT 개발자 <span className='orange'>박병현</span>입니다.<br/>
          새로운 기술을 익히는 걸 좋아하며 커뮤니티가 원활합니다.
        </p>
        <h2>PERSONAL INFOMATION</h2>
        <ul>
          <li><span className='orange'>이름</span> : 박병현</li>
          <li><span className='orange'>나이</span> : 1996년생</li>
          <li><span className='orange'>전화번호</span> : 010-4149-9405</li>
          <li><span className='orange'>주소</span> : 서울특별시 구로구</li>
          <li><span className='orange'>이메일</span> : parkbh801@naver.com</li>
        </ul>
      </div>
    </section>
  )
}


export default Intro;